import { lazy } from "react";

const Signin = lazy(() => import("./Signin"));

const Error404 = lazy(() => import("./Error"));
const DownloadDocument = lazy(() => import("./DownloadDocument"));
const DownloadTicket = lazy(() => import("./DownloadTicket"));
const DownloadTicketFacture = lazy(() => import("./DownloadTicketFacture"));
const DownloadCommande = lazy(() => import("./DownloadCommande"));
const DownloadDevis = lazy(() => import("./DownloadDevis"));
const DownloadEtatCompte = lazy(() => import("./DownloadEtatCompte"));
const Sso = lazy(() => import("./Sso"));
const DownloadAbonnementCard = lazy(() => import("./DownloadAbonnementCard"));
const DownloadJournalCompta = lazy(() => import("./DownloadJournalCompta"));

const sessionsRoutes = [
  {
    path: "/session/signin",
    component: Signin
  },
  {
    path: "/session/sso",
    component: Sso
  },
  {
    path: "/session/document/download/:id/:token",
    exact: true,
    component: DownloadDocument
  },
  {
    path: "/session/ticket/download/:id/:token",
    exact: true,
    component: DownloadTicket
  },
  {
    path: "/session/ticket/download/:company/:id/:token",
    exact: true,
    component: DownloadTicket
  },
  {
    path: "/session/ticket_facture/download/:id/:token",
    exact: true,
    component: DownloadTicketFacture
  },
  {
    path: "/session/ticket_facture/download/:company/:id/:token",
    exact: true,
    component: DownloadTicketFacture
  },
  {
    path: "/session/commande/download/:id/:token",
    exact: true,
    component: DownloadCommande
  },
  {
    path: "/session/commande/download/:company/:id/:token",
    exact: true,
    component: DownloadCommande
  },
  {
    path: "/session/devis/download/:id/:token",
    exact: true,
    component: DownloadDevis
  },
  {
    path: "/session/devis/download/:company/:id/:token",
    exact: true,
    component: DownloadDevis
  },
  {
    path: "/session/etat_compte/download/:begin/:end/:id/:token/:other_company?",
    exact: true,
    component: DownloadEtatCompte
  },
  {
    path: "/session/abonnement_card/download/:id/:token",
    exact: true,
    component: DownloadAbonnementCard
  },
  {
    path: "/session/document/download/:company/:id/:token",
    exact: true,
    component: DownloadDocument
  },
  {
    path: "/session/etat_compte/download/:company/:begin/:end/:id/:token/:other_company?",
    exact: true,
    component: DownloadEtatCompte
  },
  {
    path: "/session/abonnement_card/download/:company/:id/:token",
    exact: true,
    component: DownloadAbonnementCard
  },
  // Journaux compta / RAZ caisse envoyés par mail : lien construit par JournalComptaMailGestion::lien() côté backend
  {
    path: "/session/compta/journal/:id/:token",
    exact: true,
    component: DownloadJournalCompta
  },
  {
    path: "/session/compta/journal/:company/:id/:token",
    exact: true,
    component: DownloadJournalCompta
  },
  {
    path: "/session/404",
    component: Error404
  }
];

export default sessionsRoutes;
